import { Client } from '@zerops/models/client';
import { User } from '@zerops/models/user';
import { ProjectRole } from '@zerops/models/project';

export class ClientUser {
  accessToClientZone: boolean;
  client: Client;
  clientId: string;
  cloudDnsEnabled: boolean;
  created: string;
  id: string;
  lastUpdate: string;
  roleCode: string;
  status: ClientUserStatuses;
  user: User;
  userId: string;
  // Independent of roleCode — the API gates billing and project creation on these
  // alone, so never infer them from the role. Read them through the helpers in
  // client-user.util.
  canCreateProjects?: boolean;
  canViewFinances?: boolean;
  canEditFinances?: boolean;
  email?: string;
}

export class ClientUserWithRole extends ClientUser {
  roleIndex: number;
}

export interface ClientUserAddPayload {
  firstName: string;
  lastName: string;
  email: string;
  clientId: string;
  roleCode: string;
  canCreateProjects?: boolean;
  canViewFinances?: boolean;
  canEditFinances?: boolean;
}

export interface ClientUserUpdatePayload {
  firstName: string;
  lastName: string;
  email: string;
  roleCode: string;
  canCreateProjects?: boolean;
  canViewFinances?: boolean;
  canEditFinances?: boolean;
}

export enum ClientUserStatuses {
  active = 'ACTIVE',
  waitingAuthorization = 'WAITING_AUTHORIZATION'
}

export enum ClientUserRole {
  Owner = 'OWNER',
  Admin = 'ADMIN',
  BasicUser = 'BASIC_USER',
  ReadOnly = 'READ_ONLY',
  NoAccess = 'NO_ACCESS'
}

// Highest to lowest. Must list every role the API can return — a missing one resolves
// to indexOf() === -1 and silently breaks every hierarchy comparison built on it.
export const ClientUserRoleHierarchy: string[] = [
  ClientUserRole.Owner,
  ClientUserRole.Admin,
  ClientUserRole.BasicUser,
  ClientUserRole.ReadOnly,
  ClientUserRole.NoAccess
];

// User's project-specific roles (inverse of ProjectUserRole)
export interface UserProjectRole {
  id: string;           // Role assignment ID
  clientUserId: string; // User ID
  projectId: string;    // Project ID
  roleCode: ProjectRole; // 'ADMIN' | 'READ_ONLY'
  created: string;
  lastUpdate: string;
}

export interface UserProjectRolesResponse {
  projectRoleList: UserProjectRole[];
}

export interface UserProjectRolesPayload {
  projectRoleList: Array<{
    id: string;
    projectId: string;
    roleCode: ProjectRole;
  }>;
}

export interface ClientUserRoleDeclaration {
  globalRole: string;
  projectRole: ProjectRole;
}
